var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Status } from './types';
import { useSession } from './useSession';
export var IsAuthenticated = function (_a) {
    var children = _a.children;
    var session = useSession();
    var status = session.status;
    if (![Status.Authenticated, Status.Unauthenticating].includes(status)) {
        return null;
    }
    // @see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
    return React.createElement(React.Fragment, null, typeof children === 'function' ? children(__assign({}, session)) : children);
};
//# sourceMappingURL=IsAuthenticated.js.map